import { Link, useLocation } from "react-router-dom"
import { memo } from "react"

interface SidebarRowProps {
    to?: string
    icon?: React.ReactNode
    text: string
    style?: string
    state?: any
    toNewTab?: boolean,
    activeCheckExact?: boolean
    active?: boolean
    onClick?: () => void
    inset?: boolean
    badge?: React.ReactNode
}

const pathIsActive = (pathname: string, target?: string, exact = false) => {
    if (!target) return false
    const current = pathname.length > 1 && pathname.endsWith('/') ? pathname.slice(0, -1) : pathname
    const next = target.length > 1 && target.endsWith('/') ? target.slice(0, -1) : target
    if (exact) return current === next
    return current === next || current.startsWith(`${next}/`)
}

const SidebarRow: React.FC<SidebarRowProps> = ({ to, icon, text, onClick, style, state, toNewTab, activeCheckExact = false, active, inset = false, badge }) => {

    const location = useLocation();
    const isBordered = style === 'border' || Boolean(onClick && !inset);

    const rowClasses = `
        grid
        grid-cols-[min-content_auto_min-content]
        h-10
        items-center
        gap-2
        text-base
        cursor-pointer
        px-4
        hover:bg-blue-50
        [&>svg]:fill-black
        ${inset ? '' : 'rounded-md mx-4 mb-2 w-[calc(100%-2rem)] box-border'}
        ${isBordered ? 'border border-gray-400 bg-gray-200' : ''}
`;
    const rowClassesActive = `
        !bg-blue-100
        hover:!bg-blue-100
    `;
    const rowTextClasses = `
        text-black
        whitespace-nowrap
        select-none
    `;

    const isActive = active ?? pathIsActive(location.pathname, to, activeCheckExact);

    if (to) {
        return (
            <Link to={to} state={state} className={`${rowClasses} ${isActive && rowClassesActive}`} onClick={onClick} target={toNewTab ? "_blank" : undefined} rel={toNewTab ? "noopener noreferrer" : undefined}>
                {icon}
                <div className={rowTextClasses}>{text}</div>
                {badge}
            </Link>
        )
    } else {
        return (
            <button type="button" className={`${rowClasses} ${inset ? 'w-full' : ''} text-left ${isActive ? rowClassesActive : ''}`} onClick={onClick}>
                {icon}
                <div className={`${rowTextClasses}`}>{text}</div>
                {badge}
            </button>
        )
    }
}

export default memo(SidebarRow)

